const { io } = require('./ioHandler');
const { state } = require('./state');
const { client } = require('./client');
const { reactRender } = require('./reactRender');

const { buildName } = require('./nameBuilder');
const { signInAnonUser, endLobby, transitionToMatchmaking } = require('./lobby.js')

const { initCustomGameLobby } = require('./customGameLobby');
const { initGame } = require('./client');
const { returnToLobby, returnToCustomGameLobby } = require('./lobby.js')
 
var joinCustom = { };

joinCustom.entry = function(gameId, back) {

  reactRender.joinCustom(
    (text) => signInAnonUser(text, () => joinCustom.join(gameId, back, text)), 
    buildName(), 
    back,
  );
}

joinCustom.join = function(gameId, back, name) {

  io.emit('joinCustomGame', { gameId: gameId, createIfDoesntExist: true });

  io.on('failedCustomGameLobby', params => {
    io.off('failedCustomGameLobby');
    io.off('joinedCustomGameLobby');
    io.off('foundCustomGameWithMatchingId');
    if (params && params.msg) {
      reactRender.showAlert(params.msg);
    }
    back(name);
  });

  io.on('joinedCustomGameLobby', params => {
    endLobby();
    io.off('failedCustomGameLobby');
    io.off('joinedCustomGameLobby');
    io.off('foundCustomGameWithMatchingId');
    initCustomGameLobby(params.isAdmin, params.gameId, returnToLobby, () => initGame(false, returnToLobby, () => returnToCustomGameLobby(params.gameId), "Return to lobby"));
  });
  
  io.on('foundCustomGameWithMatchingId', params => {
    endLobby();
    io.off('failedCustomGameLobby');
    io.off('joinedCustomGameLobby');
    io.off('foundCustomGameWithMatchingId');

    const returnFunction = function() {
      if (params.gameId && params.gameId.length == 4)
        returnToCustomGameLobby(params.gameId);
      else {
        returnToLobby();
        transitionToMatchmaking();
      }
    }

    initGame(false, returnToLobby, returnFunction, gameId && gameId.length == 4 ? "Return to lobby" : undefined);
  });
}

module.exports = joinCustom;
